import { render } from "./trelloContainer.vue?vue&type=template&id=041a3317&ts=true"
import script from "./trelloContainer.vue?vue&type=script&lang=ts"
export * from "./trelloContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__